export default {"src":"/_next/static/media/lock.002272ff.svg","height":28,"width":22};